import React, { createRef, Component } from "react";

import PropTypes from "prop-types";
import { Highlight } from "react-instantsearch-dom";
import Carousel from "../components/Carousel";
import GalleryModal from "../location/thumbnailGallery/GalleryModal";
import withThumbGalleryState from "../HOC/withThumbGalleryState";
import classnames from "classnames";

class FeaturedHit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            matchedImages: null,
        };
        this.container = createRef();
    }

    static getDerivedStateFromProps(props, state) {
        if (props.hit._highlightResult.tags) {
            props.hit._highlightResult.tags = props.hit._highlightResult.tags.filter(
                tag => tag.matchLevel !== "none"
            );
        }
        let matchedImages = [];

        state.matchedImages = matchedImages;

        return state;
    }

    componentDidMount() {

    }
    componentDidUpdate(prevProps, prevState, snapshot) {

    }

    componentWillUnmount() {

    }

    render() {
        return (
            <li className={classnames("px-2 mb-3", this.props.className || null, (typeof viewMap === 'undefined' || viewMap === true) && !!!this.props.showMap ? 'col-xl-6' : 'col-md-8')}>
                {/* <article ref={this.container} className="bg-light mx-0 il-feature il-search-result il-react-carousel"> */}
                <article ref={this.container} className="bg-light mx-0 il-search-result il-react-carousel il-feature-large-screen">
                    <Carousel
                        isFeatured={true}
                        mediaTags={this.props.mediaTags}
                        locationSlug={this.props.hit.slug}
                        isActive={this.props.isActive}
                        onActiveCallback={this.props.onActiveCallback}
                        className="il-featured-height-fix d-block"
                        locationId={this.props.hit.id}
                        title={this.props.hit.title}
                        swiperProgressCallback={(swiper) => {
                            const classList = swiper.el.classList;

                            if (swiper.progress > 0) {
                                if (!classList.contains('il-feature-scrolling'))
                                    classList.add('il-feature-scrolling');
                            } else {
                                if (classList.contains('il-feature-scrolling'))
                                    classList.remove('il-feature-scrolling');
                            }
                        }}
                    >
                        <div className="d-flex flex-column justify-content-center align-items-start position-absolute il-info-content">
                            <div className="il-info-container-inner position-relative">
                                {!!this.props.hit.is_exclusive && (
                                    <span className="il-sub-title font-weight-bold mb-1">Exclusive</span>
                                )}
                                <h3 className="il-title font-weight-normal">
                                    <a target="_blank" href={`/${this.props.hit.slug}`} >
                                        {this.props.hit.title}
                                    </a>
                                </h3>
                                {!!this.props.hit.city && (
                                    <p className="il-city ellipse-overflow">
                                        {this.props.hit.city}
                                    </p>
                                )}
                                {/* {(!!this.props.hit.neighborhood || !!this.props.hit.city) && (
                                    <p className="il-city ellipse-overflow">
                                        {!!this.props.hit.city && this.props.hit.city}
                                        {!!this.props.hit.neighborhood && !!this.props.hit.city && (
                                            <span className="px-2">|</span>
                                        )}
                                        {!!this.props.hit.neighborhood && this.props.hit.neighborhood}
                                    </p>
                                )} */}
                                {this.props.hit.description && (
                                    <p className="il-description">
                                        <a className="text-white" target="_blank" href={`/${this.props.hit.slug}`}>{this.props.hit.description}</a>
                                    </p>
                                )}
                                <a className="d-inline-block btn btn-primary mt-2" href={`/${this.props.hit.slug}`}>View Location</a>

                                <button
                                    className="mt-1 il-thumb-gallery-modal-trigger btn text-white"
                                    data-toggle="modal"
                                    data-target="#il-thumb-gallery-modal"
                                    onClick={this.props.handleShow}
                                >
                                    <svg className="align-top" width="25" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M319.8 204v8c0 6.6-5.4 12-12 12h-84v84c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-84h-84c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h84v-84c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12zm188.5 293L497 508.3c-4.7 4.7-12.3 4.7-17 0l-129-129c-2.3-2.3-3.5-5.3-3.5-8.5v-8.5C310.6 395.7 261.7 416 208 416 93.8 416 1.5 324.9 0 210.7-1.5 93.7 93.7-1.5 210.7 0 324.9 1.5 416 93.8 416 208c0 53.7-20.3 102.6-53.7 139.5h8.5c3.2 0 6.2 1.3 8.5 3.5l129 129c4.7 4.7 4.7 12.3 0 17zM384 208c0-97.3-78.7-176-176-176S32 110.7 32 208s78.7 176 176 176 176-78.7 176-176z"></path></svg>
                                </button>
                            </div>
                        </div>
                    </Carousel>
                </article>
                <GalleryModal
                    locationId={this.props.hit.id}
                    title={this.props.hit.title}
                    show={this.props.show}
                    handleClose={this.props.handleClose} />
            </li>
        );
    }
}

FeaturedHit.propTypes = {
    hit: PropTypes.object.isRequired
};

export default withThumbGalleryState(FeaturedHit);
